import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import * as bie from "react-bootstrap";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import * as Yup from 'yup';
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import moment from "moment";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
export default function AffiliationCollegeCourseAcademicPerformanceDetails() {
    const hasFetchedData = useRef(false)
    const [sowCourseAcademicPerformancedata, setCourseAcademicPerformanceData] = useState([])
    const [showTotCourseAcademicPerformancedata, setTotCourseAcademicPerformanceData] = useState([])
    const dispatch = useDispatch()


    function GetClgCousreAcademicPerformanceDetails() {
        let AcdTotUrl = config.url.API_URL + "getTotAcPerformancecourses";
        let AcdlUrl = config.url.API_URL + "getAcPerformancecourse";

        CommonAxiosGet(AcdlUrl, dispatch).then((resCourse) => {
            if (resCourse?.data?.scode === "01") {
                setCourseAcademicPerformanceData(resCourse?.data?.getAcPerformancecourse)
                clgCourseAcademicPerformanceformik?.setFieldValue("rowCount", resCourse?.data?.data_count)
            }
            else {
                setCourseAcademicPerformanceData([])
                clgCourseAcademicPerformanceformik?.setFieldValue("rowCount", 0)
            }
        })
        CommonAxiosGet(AcdTotUrl, dispatch).then((restotCourse) => {
            if (restotCourse?.data?.scode === "01") {
                setTotCourseAcademicPerformanceData(restotCourse?.data?.getTotAcPerformancecourse[0])
            }
            else {
                setTotCourseAcademicPerformanceData([])
            }
        })
    }
    const ClgcourseAcadmicsPerDtlsValidation = Yup.object().shape({
        clgCourseIntake: Yup.array().of(
            Yup.object().shape({
                courseStartDate: Yup.string().required("Course start date is required").test("is-valid-date", "Invalid date", (value) => moment(value, "YYYY-MM-DD", true).isValid()).nullable(),
                universityApprovedIntake24: Yup.string().required(ERROR_MSG).nullable(),
                courseDuration24: Yup.string().notOneOf(['0'], 'Duration cannot be zero').required(ERROR_MSG).nullable(),
                admittedStrength24: Yup.string().required(ERROR_MSG).nullable(),
                attendedExams24: Yup.string().required(ERROR_MSG).nullable(),
                noOfPassedStudents24: Yup.string().required(ERROR_MSG).nullable(),

                universityApprovedIntake23: Yup.string().required(ERROR_MSG).nullable(),
                courseDuration23: Yup.string().required(ERROR_MSG).nullable(),

                attendedExams23: Yup.string().required(ERROR_MSG).nullable(),
                admittedStrength23: Yup.string().required(ERROR_MSG).nullable(),
                noOfPassedStudents23: Yup.string().required(ERROR_MSG).nullable(),
                universityApprovedIntake22: Yup.string().required(ERROR_MSG).nullable(),
                courseDuration22: Yup.string().required(ERROR_MSG).nullable(),

                admittedStrength22: Yup.string().required(ERROR_MSG).nullable(),
                attendedExams22: Yup.string().required(ERROR_MSG).nullable(),
                noOfPassedStudents22: Yup.string().required(ERROR_MSG).nullable(),
                universityApprovedIntake21: Yup.string().required(ERROR_MSG).nullable(),
                courseDuration21: Yup.string().required(ERROR_MSG).nullable(),

                admittedStrength21: Yup.string().required(ERROR_MSG).nullable(),
                attendedExams21: Yup.string().required(ERROR_MSG).nullable(),
                noOfPassedStudents21: Yup.string().required(ERROR_MSG).nullable()

            }))
    })
    const clgCourseAcademicPerformanceformik = useFormik({
        initialValues: {
            rowCount: "",
            clgCourseIntake: []
        },
        enableReinitialize: true,
        validationSchema: ClgcourseAcadmicsPerDtlsValidation,
        onSubmit: (val) => {

            Swal.fire({
                title: "Are you sure want to submit the data?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Submit",
                cancelButtonText: "Cancel",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let saveUrl = config.url.API_URL + `saveAcPerformancecourses `
                    CommonAxiosPost(saveUrl, val?.clgCourseIntake, dispatch).then((resAtsave) => {
                        if (resAtsave?.data?.scode === '01') {
                            Swal.fire('', 'Successfully Submitted', 'success').then((res) => {
                                if (res?.isConfirmed) {
                                    GetClgCousreAcademicPerformanceDetails()
                                }
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    })

    useEffect(() => {
        if (sowCourseAcademicPerformancedata) {
            const clgValues = sowCourseAcademicPerformancedata?.map(data => ({
                regSelf: data?.reg_self_code,
                mediumCode: data?.medium_code,
                courseAfflType: data?.course_affl_type,
                courseId: data?.course_id,
                courseStartDate: data?.course_start_date
                    ? moment(data.course_start_date, "DD-MM-YYYY").format("YYYY-MM-DD")
                    : "",

                universityApprovedIntake24: data?.university_approved_intake_24,
                courseDuration24: data?.course_duration_24,
                approvedIntake24: data?.approved_intake_24,
                admittedStrength24: data?.admtted_strength_24,
                attendedExams24: data?.attended_exams_24,
                noOfPassedStudents24: data?.no_of_passed_students_24,
                passPercentage24: data?.pass_percentage_24,

                universityApprovedIntake23: data?.university_approved_intake_23,
                courseDuration23: data?.course_duration_23,
                approvedIntake23: data?.approved_intake_23,
                admittedStrength23: data?.admtted_strength_23,
                attendedExams23: data?.attended_exams_23,
                noOfPassedStudents23: data?.no_of_passed_students_23,
                passPercentage23: data?.pass_percentage_23,

                universityApprovedIntake22: data?.university_approved_intake_22,
                courseDuration22: data?.course_duration_22,
                approvedIntake22: data?.approved_intake_22,
                admittedStrength22: data?.admtted_strength_22,
                attendedExams22: data?.attended_exams_22,
                noOfPassedStudents22: data?.no_of_passed_students_22,
                passPercentage22: data?.pass_percentage_22,

                universityApprovedIntake21: data?.university_approved_intake_21,
                courseDuration21: data?.course_duration_21,
                approvedIntake21: data?.approved_intake_21,
                admittedStrength21: data?.admtted_strength_21,
                attendedExams21: data?.attended_exams_21,
                noOfPassedStudents21: data?.no_of_passed_students_21,
                passPercentage21: data?.pass_percentage_21



            }));
            clgCourseAcademicPerformanceformik.setValues({ ...clgCourseAcademicPerformanceformik?.values, clgCourseIntake: clgValues });
        }
    }, [sowCourseAcademicPerformancedata]);

    const calculateApprovedIntake = (e, fieldname, index, year) => {
        let value;
        if (e !== null) {
            value = e?.target?.value
        }
        clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].${fieldname}${year}`, value)
        let intake;
        let duration;
        if (fieldname === "universityApprovedIntake") {
            intake = fieldname === "universityApprovedIntake" ? Number(value) : clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`universityApprovedIntake${year}`] ?? "";
            duration = fieldname === "courseDuration" ? Number(value) : clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`courseDuration${year}`] ?? "";
        }
        else if (fieldname === "courseDuration") {
            duration = fieldname === "courseDuration" ? Number(value) : clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`courseDuration${year}`] ?? "";
            intake = fieldname === "universityApprovedIntake" ? Number(value) : clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`universityApprovedIntake${year}`] ?? "";
        }

        // const intake = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`universityApprovedIntake${year}`] || 0, 10);
        // const duration = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`courseDuration${year}`] || 0, 10);
        const approvedIntake = intake * duration;

        clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].approvedIntake${year}`, approvedIntake || 0);
    };

    const calculatePassPercentage = (index, year) => {
        const attendedExams = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`attendedExams${year}`] || 0, 10);
        const passedStudents = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index][`noOfPassedStudents${year}`] || 0, 10);
        const passPercentage = attendedExams > 0 ? (passedStudents / attendedExams) * 100 : 0;

        clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].passPercentage${year}`, passPercentage.toFixed(2));
        if (passPercentage > 100) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Pass Percentage',
                text: 'Pass percentage cannot exceed 100%. Please enter a valid number of passed students.',
                backdrop: false,
            });

            clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].noOfPassedStudents${year}`, '');
            clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].passPercentage${year}`, '');

        }

    };

    const calculateTotals = () => {

        const totals = {
            tot_university_approved_intake_24: 0,
            tot_course_duration_24: 0,
            tot_approved_intake_24: 0,
            tot_admtted_strength_24: 0,
            tot_attended_exams_24: 0,
            tot_no_of_passed_students_24: 0,
            tot_pass_percentage_24: 0,

            tot_university_approved_intake_23: 0,
            tot_course_duration_23: 0,
            tot_approved_intake_23: 0,
            tot_admtted_strength_23: 0,
            tot_attended_exams_23: 0,
            tot_no_of_passed_students_23: 0,
            tot_pass_percentage_23: 0,

            tot_university_approved_intake_22: 0,
            tot_course_duration_22: 0,
            tot_approved_intake_22: 0,
            tot_admtted_strength_22: 0,
            tot_attended_exams_22: 0,
            tot_no_of_passed_students_22: 0,
            tot_pass_percentage_22: 0,

            tot_university_approved_intake_21: 0,
            tot_course_duration_21: 0,
            tot_approved_intake_21: 0,
            tot_admtted_strength_21: 0,
            tot_attended_exams_21: 0,
            tot_no_of_passed_students_21: 0,
            tot_pass_percentage_21: 0
        };

        clgCourseAcademicPerformanceformik.values.clgCourseIntake.forEach((data, index) => {
            totals.tot_university_approved_intake_24 += parseFloat(data.universityApprovedIntake24 || 0);
            totals.tot_course_duration_24 += parseFloat(data.courseDuration24 || 0);

            totals.tot_approved_intake_24 += parseFloat(data.approvedIntake24 || 0);

            totals.tot_admtted_strength_24 += parseInt(data.admittedStrength24 || 0);
            totals.tot_attended_exams_24 += parseFloat(data.attendedExams24 || 0);
            totals.tot_no_of_passed_students_24 += parseFloat(data.noOfPassedStudents24 || 0);
            totals.tot_pass_percentage_24 += parseFloat(data.passPercentage24 || 0);

            totals.tot_university_approved_intake_23 += parseFloat(data.universityApprovedIntake23 || 0);
            totals.tot_course_duration_23 += parseFloat(data.courseDuration23 || 0);
            totals.tot_approved_intake_23 += parseFloat(data.approvedIntake23 || 0);
            totals.tot_admtted_strength_23 += parseInt(data.admittedStrength23 || 0);
            totals.tot_attended_exams_23 += parseFloat(data.attendedExams23 || 0);
            totals.tot_no_of_passed_students_23 += parseFloat(data.noOfPassedStudents23 || 0);
            totals.tot_pass_percentage_23 += parseFloat(data.passPercentage23 || 0);

            totals.tot_university_approved_intake_22 += parseFloat(data.universityApprovedIntake22 || 0);
            totals.tot_course_duration_22 += parseFloat(data.courseDuration22 || 0);
            totals.tot_approved_intake_22 += parseFloat(data.approvedIntake22 || 0);
            totals.tot_admtted_strength_22 += parseInt(data.admittedStrength22 || 0);
            totals.tot_attended_exams_22 += parseFloat(data.attendedExams22 || 0);
            totals.tot_no_of_passed_students_22 += parseFloat(data.noOfPassedStudents22 || 0);
            totals.tot_pass_percentage_22 += parseFloat(data.passPercentage22 || 0);

            totals.tot_university_approved_intake_21 += parseFloat(data.universityApprovedIntake21 || 0);
            totals.tot_course_duration_21 += parseFloat(data.courseDuration21 || 0);
            totals.tot_approved_intake_21 += parseFloat(data.approvedIntake21 || 0);
            totals.tot_admtted_strength_21 += parseInt(data.admittedStrength21 || 0);
            totals.tot_attended_exams_21 += parseFloat(data.attendedExams21 || 0);
            totals.tot_no_of_passed_students_21 += parseFloat(data.noOfPassedStudents21 || 0);
            totals.tot_pass_percentage_21 += parseFloat(data.passPercentage21 || 0);
        });


        Object.keys(totals).forEach((key) => {
            const currentValue = clgCourseAcademicPerformanceformik.values[key];
            // if (totals[key] !== currentValue) {
            clgCourseAcademicPerformanceformik.setFieldValue(key, totals[key]);
            // }
        });

    };
    // const getDisplayValue = (formikValue, fallbackValue) => {
    //     return formikValue !== '' && formikValue !== undefined && formikValue !== null
    //         ? formikValue
    //         : fallbackValue || '';
    // };
    const getDisplayValue = (formikValue, apiValue) => {
        // alert("total couse duration", formikValue, apiValue);
        if (formikValue !== '' && formikValue !== undefined && formikValue !== null) {
            return formikValue;
        }
        // If Formik value is not valid, return API value or fallback to an empty string
        return apiValue || '';
    };

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetClgCousreAcademicPerformanceDetails()
            hasFetchedData.current = true
        }
    }, [])

    const validatePassedVsAttended = (index, year) => {
        const attended = document.querySelector(`[name="clgCourseIntake[${index}].attendedExams${year}"]`)?.value;
        const passed = document.querySelector(`[name="clgCourseIntake[${index}].noOfPassedStudents${year}"]`)?.value;

        const attendedNum = parseInt(attended, 10) || 0;
        const passedNum = parseInt(passed, 10) || 0;

        if (passedNum > attendedNum) {
            Swal.fire({
                title: `Invalid Data`,
                text: 'Number of passed students cannot be more than number of attended students.',
                backdrop: false,
            }).then(() => {
                // Clear the invalid field after user closes the alert
                clgCourseAcademicPerformanceformik.setFieldValue(
                    `clgCourseIntake[${index}].noOfPassedStudents${year}`,
                    ''
                );
            });
        }
    };

    const validateAttendedNotGreater = (index, year) => {
        const attended = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index]?.[`attendedExams${year}`], 10) || 0;
        const admitted = parseInt(clgCourseAcademicPerformanceformik.values.clgCourseIntake[index]?.[`admittedStrength${year}`], 10) || 0;


        if (attended > admitted) {
            Swal.fire({
                icon: 'warning',
                text: `Row ${index + 1}  Attended Exams cannot be greater than Admitted Strength.`,
            });

            // Optionally reset the value
            clgCourseAcademicPerformanceformik.setFieldValue(`clgCourseIntake[${index}].attendedExams${year}`, '');
        }
    };

    return (
        <>
            <bie.Container fluid className="px-1" >
                <CommonFormHeading heading={"Academic Performance Details"} />

                {/* <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11} className="">
                        <div className="inner-herbpage-service-title1">
                            <h1>{`Academic Performance Details`}</h1>
                        </div>
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                        <button className="breadcrumb-item"><a href="/dashboard" className='affl-dash'><FaHome size={30} /></a></button>
                    </bie.Col>
                </bie.Row> */}
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={clgCourseAcademicPerformanceformik}>
                        <Form onChange={clgCourseAcademicPerformanceformik?.handleChange} onSubmit={clgCourseAcademicPerformanceformik?.handleSubmit} className="form_adjust" >
                            {sowCourseAcademicPerformancedata?.length > 0 ? (<>

                                <center>
                                    <br />
                                    <font style={{ fontFamily: "sans-serif", fontSize: "14px", color: "red", fontweight: "bold" }}>
                                        Note: ** Please enter 0 if the field is not applicable </font></center>

                            </>) : (<center className='text-danger h5 pt-5'>***** No Data Found *****</center>
                            )}
                            {sowCourseAcademicPerformancedata?.length > 0 ? <>

                                <div className="table-responsive">
                                    <table className="sticky-table affl-table table-bordered">
                                        <thead className="sticky-header">
                                            <tr>
                                                <th rowSpan={3}>Slno</th><th rowSpan={3}>Course/Programme</th><th rowSpan={3}>Branch/Combination</th><th rowSpan={3}>Year of<br />Starting Course</th><th colSpan={28} >Details of Academic Performance year wise</th>
                                            </tr>
                                            <tr>
                                                <th colSpan={7} >2024-25</th>    <th colSpan={7} >2023-24</th><th colSpan={7} >2022-23</th><th colSpan={7} >2021-22</th>
                                            </tr>
                                            <tr>
                                                <th rowSpan={1} >University Approved Intake	</th>
                                                <th colSpan={1} >Course Duration</th><th colSpan={1} >Approved Intake (Cumulative of all Course duration years)</th><th colSpan={1} > Admitted Strength (Cumulative of all Course duration years)</th><th colSpan={1} >Attended Exams (Cumulative)</th><th colSpan={1} >Number of Passed students (Cumulative)</th><th colSpan={1} >Pass Percentage</th>

                                                <th rowSpan={1} >University Approved Intake	</th><th colSpan={1} >Course Duration</th>
                                                <th colSpan={1} >Approved Intake (Cumulative of all Course duration years)</th><th colSpan={1} > Admitted Strength (Cumulative of all Course duration years)</th><th colSpan={1} >Attended Exams (Cumulative)</th><th colSpan={1} >Number of Passed students (Cumulative)</th><th colSpan={1} >Pass Percentage</th>

                                                <th rowSpan={1} >University Approved Intake	</th>
                                                <th colSpan={1} >Course Duration</th><th colSpan={1} >Approved Intake (Cumulative of all Course duration years)</th><th colSpan={1} > Admitted Strength (Cumulative of all Course duration years)</th><th colSpan={1} >Attended Exams (Cumulative)</th><th colSpan={1} >Number of Passed students (Cumulative)</th><th colSpan={1} >Pass Percentage</th>

                                                <th rowSpan={1} >University Approved Intake	</th><th colSpan={1} >Course Duration</th><th colSpan={1} >Approved Intake (Cumulative of all Course duration years)</th><th colSpan={1} > Admitted Strength (Cumulative of all Course duration years)</th><th colSpan={1} >Attended Exams (Cumulative)</th><th colSpan={1} >Number of Passed students (Cumulative)</th><th colSpan={1} >Pass Percentage</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {sowCourseAcademicPerformancedata && sowCourseAcademicPerformancedata?.map((data, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td style={{ textAlign: "left" }}>
                                                        {`${data.course_cat_name}(${data.medium})/${data.reg_self}/${data.course_affl_type}`}
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].regSelf`} /><Field type="hidden" name={`clgCourseIntake[${index}].mediumCode`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].acYear`} /><Field type="hidden" name={`clgCourseIntake[${index}].collegeCode`} />
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].courseAfflType`} />
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>
                                                        {data.course_name}
                                                        <Field type="hidden" name={`clgCourseIntake[${index}].courseId`} />
                                                    </td>
                                                    <td>  <Field type="date" className="form-control" name={`clgCourseIntake[${index}].courseStartDate`}
                                                        onKeyDown={(e) => { e.preventDefault() }} max={new Date().toISOString().split('T')[0]} min={"1970-01-01"} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseStartDate`} className='text-error' component='div' />

                                                    </td>
                                                    <td>
                                                        {/* <Field type="text" className="form-control" name={`clgCourseIntake[${index}].universityApprovedIntake24`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        maxLength="3"
                                                        onKeyUp={() => { calculateTotals() }} onClick={() => { calculateApprovedIntake(index, '24'); }} /> */}


                                                        <Field
                                                            type="text"
                                                            className="form-control"
                                                            name={`clgCourseIntake[${index}].universityApprovedIntake24`}
                                                            onPaste={(e) => handlePaste(e)}
                                                            onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                            maxLength="5"
                                                            onKeyUp={() => { calculateTotals() }}
                                                            onChange={(e) => { calculateApprovedIntake(e, "universityApprovedIntake", index, '24'); }}
                                                        />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].universityApprovedIntake24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].courseDuration24`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        maxLength="1" onKeyUp={() => { calculateTotals(); }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "courseDuration", index, '24'); }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseDuration24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approvedIntake24`}
                                                        maxLength="5" disabled="true" />
                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admittedStrength24`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        maxLength="6"
                                                        onKeyUp={() => { calculateTotals(); validateAttendedNotGreater(index, '24') }}
                                                    />

                                                        <ErrorMessage name={`clgCourseIntake[${index}].admittedStrength24`} className='text-error' component='div' />

                                                    </td>
                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].attendedExams24`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); calculateTotals(); }}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '24'); validateAttendedNotGreater(index, '24') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].attendedExams24`} className='text-error' component='div' />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfPassedStudents24`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e); calculateTotals() }}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '24'); validatePassedVsAttended(index, '24') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfPassedStudents24`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].passPercentage24`}
                                                        maxLength="5" disabled="true" /></td>


                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].universityApprovedIntake23`}
                                                        onPaste={(e) => handlePaste(e)}
                                                        maxLength="5" onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "universityApprovedIntake", index, '23'); }}

                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].universityApprovedIntake23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].courseDuration23`}
                                                        onPaste={(e) => handlePaste(e)}
                                                        maxLength="2" onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "courseDuration", index, '23'); }}

                                                    // calculateApprovedIntake(index, '23'); calculateTotals() }}
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseDuration23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approvedIntake23`} maxLength="3" disabled="true" /></td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admittedStrength23`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="6" onKeyUp={() => { calculateTotals(); validateAttendedNotGreater(index, '23') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].admittedStrength23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].attendedExams23`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '23'); calculateTotals(); validateAttendedNotGreater(index, '23') }}
                                                    // onBlur={() => { validatePassedVsAttended(index, '23'); }}
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].attendedExams23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfPassedStudents23`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '23'); calculateTotals(); validatePassedVsAttended(index, '23') }}
                                                    // onKeyUp={() => { validatePassedVsAttended(index, '23'); }}
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfPassedStudents23`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].passPercentage23`}
                                                        maxLength="5" disabled="true" /></td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].universityApprovedIntake22`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5"
                                                        // onKeyUp={() => { calculateApprovedIntake(index, '22'); calculateTotals() }} 
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "universityApprovedIntake", index, '22'); }}

                                                    />

                                                        <ErrorMessage name={`clgCourseIntake[${index}].universityApprovedIntake22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].courseDuration22`}
                                                        maxLength="5"
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "courseDuration", index, '22'); }}
                                                    // onKeyUp={() => { calculateApprovedIntake(index, '22'); calculateTotals() }}
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseDuration22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approvedIntake22`}
                                                        maxLength="5" disabled="true" />


                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admittedStrength22`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="6" onKeyUp={() => { calculateTotals(); validateAttendedNotGreater(index, '22') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].admittedStrength22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].attendedExams22`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '22'); calculateTotals(); validateAttendedNotGreater(index, '22') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].attendedExams22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfPassedStudents22`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '22'); calculateTotals(); validatePassedVsAttended(index, '22') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfPassedStudents22`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].passPercentage22`}
                                                        maxLength="5" disabled="true" /></td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].universityApprovedIntake21`}
                                                        onPaste={(e) => allowNumbersOnly(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5"
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "universityApprovedIntake", index, '21'); }}
                                                    // onKeyUp={() => { calculateApprovedIntake(index, '21'); calculateTotals() }} 
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].universityApprovedIntake21`} className='text-error' component='div' />

                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].courseDuration21`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="3"
                                                        onKeyUp={() => { calculateTotals() }}
                                                        onChange={(e) => { calculateApprovedIntake(e, "courseDuration", index, '21'); }}
                                                    // onKeyUp={() => { calculateApprovedIntake(index, '21'); calculateTotals() }} 
                                                    />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].courseDuration21`} className='text-error' component='div' />
                                                    </td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].approvedIntake21`}
                                                        maxLength="5" disabled="true" /></td>

                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].admittedStrength21`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="6" onKeyUp={() => { calculateTotals(); validateAttendedNotGreater(index, '21') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].admittedStrength21`} className='text-error' component='div' />
                                                    </td>
                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].attendedExams21`}
                                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => allowNumbersOnly(e)}
                                                        maxLength="5" onKeyUp={() => { calculatePassPercentage(index, '21'); calculateTotals(); validateAttendedNotGreater(index, '21') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].attendedExams21`} className='text-error' component='div' />
                                                    </td>
                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].noOfPassedStudents21`}
                                                        maxLength="3" onKeyUp={() => { calculatePassPercentage(index, '21'); calculateTotals(); validatePassedVsAttended(index, '21') }} />
                                                        <ErrorMessage name={`clgCourseIntake[${index}].noOfPassedStudents21`} className='text-error' component='div' />
                                                    </td>
                                                    <td>  <Field type="text" className="form-control" name={`clgCourseIntake[${index}].passPercentage21`}
                                                        maxLength="5" disabled="true" /></td>
                                                </tr>
                                            ))}

                                            <tr style={{ backgroundColor: "#E8E3D1" }}>
                                                <td colSpan="4">Total</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_university_approved_intake_24, showTotCourseAcademicPerformancedata?.tot_university_approved_intake_24)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_course_duration_24, showTotCourseAcademicPerformancedata?.tot_course_duration_24)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_approved_intake_24, showTotCourseAcademicPerformancedata?.tot_approved_intake_24)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_admtted_strength_24, showTotCourseAcademicPerformancedata?.tot_admtted_strength_24)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_attended_exams_24, showTotCourseAcademicPerformancedata?.tot_attended_exams_24)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_no_of_passed_students_24, showTotCourseAcademicPerformancedata?.tot_no_of_passed_students_24)}</td>
                                                <td>{/* Optional: pass percentage 24 */}</td>
                                                {/* 2023 */}
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_university_approved_intake_23, showTotCourseAcademicPerformancedata?.tot_university_approved_intake_23)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_course_duration_23, showTotCourseAcademicPerformancedata?.tot_course_duration_23)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_approved_intake_23, showTotCourseAcademicPerformancedata?.tot_approved_intake_23)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_admtted_strength_23, showTotCourseAcademicPerformancedata?.tot_admtted_strength_23)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_attended_exams_23, showTotCourseAcademicPerformancedata?.tot_attended_exams_23)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_no_of_passed_students_23, showTotCourseAcademicPerformancedata?.tot_no_of_passed_students_23)}</td>
                                                <td>{/* Optional: pass percentage 23 */}</td>

                                                {/* 2022 */}
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_university_approved_intake_22, showTotCourseAcademicPerformancedata?.tot_university_approved_intake_22)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_course_duration_22, showTotCourseAcademicPerformancedata?.tot_course_duration_22)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_approved_intake_22, showTotCourseAcademicPerformancedata?.tot_approved_intake_22)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_admtted_strength_22, showTotCourseAcademicPerformancedata?.tot_admtted_strength_22)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_attended_exams_22, showTotCourseAcademicPerformancedata?.tot_attended_exams_22)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_no_of_passed_students_22, showTotCourseAcademicPerformancedata?.tot_no_of_passed_students_22)}</td>
                                                <td>{/* Optional: pass percentage 22 */}</td>

                                                {/* 2021 */}
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_university_approved_intake_21, showTotCourseAcademicPerformancedata?.tot_university_approved_intake_21)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_course_duration_21, showTotCourseAcademicPerformancedata?.tot_course_duration_21)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_approved_intake_21, showTotCourseAcademicPerformancedata?.tot_approved_intake_21)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_admtted_strength_21, showTotCourseAcademicPerformancedata?.tot_admtted_strength_21)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_attended_exams_21, showTotCourseAcademicPerformancedata?.tot_attended_exams_21)}</td>
                                                <td>{getDisplayValue(clgCourseAcademicPerformanceformik?.values?.tot_no_of_passed_students_21, showTotCourseAcademicPerformancedata?.tot_no_of_passed_students_21)}</td>
                                                <td>{/* Optional: pass percentage 21 */}</td>

                                                {/* 2020 */}

                                            </tr>

                                        </tbody>
                                    </table>


                                </div>
                                <bie.Row className="px-3 pt-4">
                                    <div className='d-flex flex-row justify-content-end pb-1'>
                                        <button type="submit" className="btn rounded-0 btn-success btn-sm">Save</button>
                                    </div>
                                </bie.Row>
                            </> : null}
                            {sowCourseAcademicPerformancedata.length > 0 && (<>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th rowspan={3}>Slno</th>
                                                <th rowspan={3}>Course/Programme</th>
                                                <th rowspan={3}>Branch/Combination</th>
                                                <th rowspan={3}>Year of<br />Starting Course</th>

                                                <th colspan={32} >Details of Intake year wise</th>
                                            </tr>
                                            <tr>
                                                <th colspan={7} >2024-25</th>
                                                <th colspan={7} >2023-24</th>
                                                <th colspan={7} >2022-23</th>
                                                <th colspan={7} >2021-22</th>

                                            </tr>
                                            <tr>
                                                <th rowspan={1} >University Approved Intake	</th>
                                                <th colspan={1} >Course Duration</th>
                                                <th colspan={1} >Approved Intake (Cumulative of all Course duration years)</th>
                                                <th colspan={1} > Admitted Strength (Cumulative of all Course duration years)</th>
                                                <th colspan={1} >Attended Exams (Cumulative)</th>
                                                <th colspan={1} >Number of Passed students (Cumulative)</th>
                                                <th colspan={1} >Pass Percentage</th>

                                                <th rowspan={1} >University Approved Intake	</th>
                                                <th colspan={1} >Course Duration</th>
                                                <th colspan={1} >Approved Intake (Cumulative of all Course duration years)</th>
                                                <th colspan={1} > Admitted Strength (Cumulative of all Course duration years)</th>
                                                <th colspan={1} >Attended Exams (Cumulative)</th>
                                                <th colspan={1} >Number of Passed students (Cumulative)</th>
                                                <th colspan={1} >Pass Percentage</th>

                                                <th rowspan={1} >University Approved Intake	</th>
                                                <th colspan={1} >Course Duration</th>
                                                <th colspan={1} >Approved Intake (Cumulative of all Course duration years)</th>
                                                <th colspan={1} > Admitted Strength (Cumulative of all Course duration years)</th>
                                                <th colspan={1} >Attended Exams (Cumulative)</th>
                                                <th colspan={1} >Number of Passed students (Cumulative)</th>
                                                <th colspan={1} >Pass Percentage</th>

                                                <th rowspan={1} >University Approved Intake	</th>
                                                <th colspan={1} >Course Duration</th>
                                                <th colspan={1} >Approved Intake (Cumulative of all Course duration years)</th>
                                                <th colspan={1} > Admitted Strength (Cumulative of all Course duration years)</th>
                                                <th colspan={1} >Attended Exams (Cumulative)</th>
                                                <th colspan={1} >Number of Passed students (Cumulative)</th>
                                                <th colspan={1} >Pass Percentage</th>
                                            </tr>

                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {sowCourseAcademicPerformancedata && sowCourseAcademicPerformancedata?.map((data1, i) => (
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td >
                                                        {`${data1?.course_cat_name}(${data1?.medium})/${data1?.reg_self}/${data1?.course_affl_type}`}
                                                    </td>

                                                    <td > {data1?.course_name ?? "-"} </td>
                                                    <td>{data1?.course_start_date ?? "-"}</td>
                                                    <td>{data1?.university_approved_intake_24 ?? "-"}</td>
                                                    <td>{data1?.course_duration_24 ?? "-"} </td>
                                                    <td>{data1?.approved_intake_24 ?? "-"}</td>
                                                    <td>{data1?.admtted_strength_24 ?? "-"}</td>
                                                    <td>{data1?.attended_exams_24 ?? "-"}</td>
                                                    <td>{data1?.no_of_passed_students_24 ?? "-"} </td>
                                                    <td>{data1?.pass_percentage_24 ?? "-"} </td>

                                                    <td>{data1?.university_approved_intake_23 ?? "-"}</td>
                                                    <td>{data1?.course_duration_23 ?? "-"} </td>
                                                    <td>{data1?.approved_intake_23 ?? "-"}</td>
                                                    <td>{data1?.admtted_strength_23 ?? "-"}</td>
                                                    <td>{data1?.attended_exams_23 ?? "-"}</td>
                                                    <td>{data1?.no_of_passed_students_23 ?? "-"} </td>
                                                    <td>{data1?.pass_percentage_23 ?? "-"} </td>

                                                    <td>{data1?.university_approved_intake_22 ?? "-"}</td>
                                                    <td>{data1?.course_duration_22 ?? "-"} </td>
                                                    <td>{data1?.approved_intake_22 ?? "-"}</td>
                                                    <td>{data1?.admtted_strength_22 ?? "-"}</td>
                                                    <td>{data1?.attended_exams_22 ?? "-"}</td>
                                                    <td>{data1?.no_of_passed_students_22 ?? "-"} </td>
                                                    <td>{data1?.pass_percentage_22 ?? "-"} </td>

                                                    <td>{data1?.university_approved_intake_21 ?? "-"}</td>
                                                    <td>{data1?.course_duration_21 ?? "-"} </td>
                                                    <td>{data1?.approved_intake_21 ?? "-"}</td>
                                                    <td>{data1?.admtted_strength_21 ?? "-"}</td>
                                                    <td>{data1?.attended_exams_21 ?? "-"}</td>
                                                    <td>{data1?.no_of_passed_students_21 ?? "-"} </td>
                                                    <td>{data1?.pass_percentage_21 ?? "-"} </td>



                                                </tr>
                                            ))}
                                            <tr></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </>)}
                        </Form>
                    </FormikProvider >
                </bie.Container>
            </bie.Container>
        </>
    )
}
